import { InferType, object, string } from 'yup'

import { requiredMessage } from 'directFlow/state/config/content'

export const registrationDefaultValues = {
  regPlate: undefined,
}

export const registrationSchema = object({
  regPlate: string().required(requiredMessage),
})

export type RegistrationSchemaType = InferType<typeof registrationSchema>
